import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const user = {
  fetchUsers: lazyModuleMethod(() => import('./fetchUsers'), 'default'),
  fetchUser: lazyModuleMethod(() => import('./fetchUser'), 'default'),
  banUser: lazyModuleMethod(() => import('./banUser'), 'default'),
  createUser: lazyModuleMethod(() => import('./createUser'), 'default'),
  editUser: lazyModuleMethod(() => import('./editUser'), 'default'),
  deleteUser: lazyModuleMethod(() => import('./deleteUser'), 'default'),
  fetchCommentAdminUsers: lazyModuleMethod(
    () => import('./fetchCommentAdminUsers'),
    'default'
  ),
  fetchProfile: lazyModuleMethod(() => import('./fetchProfile'), 'default'),
  rotateTgProxy: lazyModuleMethod(() => import('./rotateTgProxy'), 'default'),
}
